import { Component, OnInit } from "@angular/core";
import { NgxSpinnerService } from "ngx-spinner";
import { Utils } from "src/app/common/utils";
import { VproService } from "src/app/service/vpro/vpro.service";
import Swal from "sweetalert2";
const Toast = Swal.mixin({
  toast: true,
  position: "top",
  showConfirmButton: false,
  timer: 3500,
});

@Component({
  selector: "app-physician-transaction",
  templateUrl: "./physician-transaction.component.html",
  styleUrls: ["./physician-transaction.component.css"],
})
export class PhysicianTransactionComponent implements OnInit {
  constructor(
    private service: VproService,
    private spinner: NgxSpinnerService
  ) {}

  transactions: any;
  allTransactions: any;
  noTransactions: boolean = false;
  activeBtn: string;
  transactionStatus = Utils.TRANSACTION_STATUS;
  selectedTransactions: any;
  dateFormat = Utils.DATE_FORMAT;
  ngOnInit() {
    this.getTransactions();
  }

  // Finction to get all transactions
  getTransactions() {
    let data = {
      org_code: localStorage.getItem("orgcode"),
    };

    this.spinner.show();
    this.service
      .getPhysicianById(localStorage.getItem("uid"), "?fields=transactions")
      .subscribe(
        (res) => {
          this.spinner.hide();
          console.log("response", res);

          this.transactions = res["transactions"];

          if (this.transactions && this.transactions.length) {
            // Map transacion status from Constants
            this.transactions = this.transactions.map((t) => {
              t["status"] = t.on_hold
                ? this.transactionStatus.ON_HOLD
                : this.transactionStatus.PROCESSED;
              return t;
            });
            this.allTransactions = this.transactions;
            this.noTransactions = false;

            this.transactions.forEach((aptime) => {
              if (aptime) aptime.aptime = Utils.formatTime(aptime.aptime);
            });
          } else {
            this.noTransactions = true;
          }
        },
        (error) => {
          console.log(error);
          this.spinner.hide();
          let msg =
            error && error.error && error.error.message
              ? error.error.message
              : "Something went wrong. Please try again.";
          this.showToast("error", msg);
        }
      );
  }

  // Function to filter Transactions array
  filterTransactions(type: string = "") {
    this.activeBtn = type;
    this.transactions = this.allTransactions;
    if (type && this.transactions)
      this.transactions = this.transactions.filter((t) => t.status == type);
  }

  showToast(type, title) {
    Toast.fire({
      type: type,
      title: title,
    });
  }

  markSelected() {
    this.selectedTransactions = this.allTransactions.filter((value, index) => {
      return value.isChecked;
    });
  }

  // function to payout
  payout() {
    let data = this.selectedTransactions.map((t) =>
      Utils.removeNullAndEmpty({
        id: t.id,
        amount: t.amount,
        status: t.status,
        aptid: t.notes && t.notes.aptid ? t.notes.aptid : "",
      })
    );
    this.spinner.show();
    this.service
      .payouts(localStorage.getItem("uid"), { transactions: data })
      .subscribe(
        (res) => {
          this.spinner.hide();
          this.showToast("success", "Payout successfully");
        },
        (error) => {
          console.log(error);
          this.spinner.hide();
          let msg =
            error && error.error && error.error.message
              ? error.error.message
              : "Something went wrong. Please try again.";
          this.showToast("error", msg);
        }
      );
  }
}
